import React from 'react';
import { CheckIcon, PackageOpenIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { volumes } from '../../data/landing';
export function Volumes() {
  return <section className="bg-cream py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-296" data-mp="2x1070x8z2f7i">
      <div className="mx-auto max-w-5xl px-4 sm:px-5" data-id="element-297" data-mp="2szoo1aklss8a">
        <div className="text-center" data-id="element-298" data-mp="2sywt81ytyyj2">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-navy-900" data-id="element-299" data-mp="2t2157lijeyka">
            <PackageOpenIcon className="h-6 w-6 text-brand-400" aria-hidden="true" data-id="element-300" data-mp="2j9vdmcw76j5m" />
          </span>
          <h2 id="volumes-title" className="mx-auto mt-4 max-w-3xl text-balance font-display text-[2rem] font-black leading-tight text-navy-900 sm:text-5xl" data-id="element-301" data-mp="2eas7sq8e88wl">
            What’s Inside the Hernia Clinical Playbook™?
          </h2>
          <p className="mt-4 text-lg text-navy-900/75" data-id="element-302" data-mp="259arp7uzk77w">6 professional volumes. One complete clinical system.</p>
        </div>

        <div className="mt-10 space-y-5" data-id="element-303" data-mp="20ddehaf0rgzc">
          {volumes.map(volume => <article key={volume.numeral} className="overflow-hidden rounded-3xl bg-white ring-1 ring-navy-900/10 lg:grid lg:grid-cols-[180px_1fr]" data-id="element-304" data-mp="333jdxw0j3834">
              <div className="flex items-center gap-3 px-6 py-4 text-white lg:flex-col lg:justify-center lg:gap-1 lg:py-8" style={{
            backgroundColor: volume.accent
          }} data-id="element-305" data-mp="2u6skzsh9w9cr">
                <span className="text-xs font-extrabold uppercase tracking-[0.2em] text-white/85" data-id="element-306" data-mp="3luaw9n2hu8tn">Volume</span>
                <span className="font-display text-3xl font-black leading-none lg:text-6xl" data-id="element-307" data-mp="3cvfqud79x2re">{volume.numeral}</span>
              </div>
              <div className="p-6 sm:p-8" data-id="element-308" data-mp="3htqziklu1781">
                <h3 className="font-display text-2xl font-black leading-tight text-navy-900 sm:text-3xl" data-id="element-309" data-mp="3hwmz0ddbw3yl">
                  {volume.title}
                </h3>
                {volume.description.map(p => <p key={p} className="mt-3 text-base leading-relaxed text-navy-900/75" data-id="element-310" data-mp="26d0psri79x9o">
                    {p}
                  </p>)}
                <p className="mt-6 text-sm font-extrabold uppercase tracking-wide text-navy-900" data-id="element-311" data-mp="713j896qmvjl">Inside you’ll find:</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-312" data-mp="27iqownwytrs">
                  {volume.items.map(item => <li key={item} className="flex gap-2.5 text-base leading-snug text-navy-900/85" data-id="element-313" data-mp="3ubbgehx5v4c5">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                  color: volume.accent
                }} strokeWidth={3} aria-hidden="true" data-id="element-314" data-mp="3keyfayzado7d" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <CtaButton className="mt-12" label="I want all 6 volumes today" data-id="element-315" data-mp="19n6rfh7tudaz" />
      </div>
    </section>;
}